import { IStore } from "services/indexdb/interface/istore"
import { RdsIdUnique } from "./indexes"

export const SourceDefinitionStore: IStore = {
    Name: 'SourceManifest',
    PrimaryField: 'name',
    Indexes: [RdsIdUnique],
    minimumVersion: 0
}
